var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":_vm.showSeconds,"variant":_vm.variant,"dismissible":"","fade":""},on:{"dismissed":function($event){_vm.showSeconds=0}}},_vm._l((_vm.messages),function(msg,index){return _c('span',{key:index},[_vm._v(_vm._s(msg))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }